import type { Template } from "@/types";

export const PO_06_H4_V2: Template[] = [
    {
        id: "po-06-h4v2-01",
        name: "PO 01 - H4V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h4_v2_01.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 52, y: 165, width: 504, height: 402, rotation: 0, imageRotation: 0 },
            { id: "2", x: 52, y: 575, width: 163, height: 114, rotation: 0, imageRotation: 0 },
            { id: "3", x: 223, y: 575, width: 163, height: 114, rotation: 0, imageRotation: 0 },
            { id: "4", x: 394, y: 575, width: 162, height: 114, rotation: 0, imageRotation: 0 },
            { id: "5", x: 648, y: 232, width: 241, height: 386, rotation: 0, imageRotation: 0 },
            { id: "6", x: 897, y: 232, width: 241, height: 386, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h4v2-02",
        name: "PO 02 - H4V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h4_v2_02.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 57, y: 172, width: 493, height: 325, rotation: 0, imageRotation: 0 },
            { id: "2", x: 57, y: 505, width: 243, height: 174, rotation: 0, imageRotation: 0 },
            { id: "3", x: 308, y: 505, width: 243, height: 174, rotation: 0, imageRotation: 0 },
            { id: "4", x: 699, y: 171, width: 387, height: 250, rotation: 0, imageRotation: 0 },
            { id: "5", x: 699, y: 429, width: 190, height: 250, rotation: 0, imageRotation: 0 },
            { id: "6", x: 897, y: 429, width: 189, height: 250, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h4v2-03",
        name: "PO 03 - H4V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h4_v2_03.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 79, y: 164, width: 201, height: 329, rotation: 0, imageRotation: 0 },
            { id: "2", x: 79, y: 500, width: 121, height: 185, rotation: 0, imageRotation: 0 },
            { id: "3", x: 208, y: 500, width: 309, height: 185, rotation: 0, imageRotation: 0 },         
            { id: "4", x: 288, y: 164, width: 229, height: 161, rotation: 0, imageRotation: 0 },
            { id: "5", x: 288, y: 333, width: 229, height: 160, rotation: 0, imageRotation: 0 },
            { id: "6", x: 650, y: 252, width: 484, height: 346, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h4v2-04",
        name: "PO 04 - H4V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h4_v2_04.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 53, y: 254, width: 492, height: 342, rotation: 0, imageRotation: 0 },
            { id: "2", x: 639, y: 163, width: 248, height: 403, rotation: 0, imageRotation: 0 },
            { id: "3", x: 895, y: 163, width: 248, height: 403, rotation: 0, imageRotation: 0 },
            { id: "4", x: 639, y: 573, width: 163, height: 114, rotation: 0, imageRotation: 0 },
            { id: "5", x: 810, y: 573, width: 162, height: 114, rotation: 0, imageRotation: 0 },
            { id: "6", x: 980, y: 573, width: 162, height: 114, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h4v2-05",
        name: "PO 05 - H4V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h4_v2_05.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 52, y: 177, width: 307, height: 495, rotation: 0, imageRotation: 0 },
            { id: "2", x: 367, y: 429, width: 171, height: 243, rotation: 0, imageRotation: 0 },
            { id: "3", x: 367, y: 177, width: 171, height: 118, rotation: 0, imageRotation: 0 },
            { id: "4", x: 367, y: 303, width: 171, height: 118, rotation: 0, imageRotation: 0 },
            { id: "5", x: 719, y: 178, width: 347, height: 243, rotation: 0, imageRotation: 0 },
            { id: "6", x: 719, y: 429, width: 347, height: 243, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h4v2-06",
        name: "PO 06 - H4V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h4_v2_06.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 61, y: 256, width: 213, height: 337, rotation: 0, imageRotation: 0 },
            { id: "2", x: 282, y: 256, width: 151, height: 107, rotation: 0, imageRotation: 0 },
            { id: "3", x: 282, y: 371, width: 151, height: 107, rotation: 0, imageRotation: 0 },
            { id: "4", x: 282, y: 486, width: 151, height: 107, rotation: 0, imageRotation: 0 },
            { id: "5", x: 441, y: 256, width: 212, height: 337, rotation: 0, imageRotation: 0 },
            { id: "6", x: 660, y: 256, width: 469, height: 337, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h4v2-07",
        name: "PO 07 - H4V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h4_v2_07.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 60, y: 163, width: 647, height: 524, rotation: 0, imageRotation: 0 },
            { id: "2", x: 715, y: 163, width: 167, height: 258, rotation: 0, imageRotation: 0 },
            { id: "3", x: 715, y: 429, width: 167, height: 258, rotation: 0, imageRotation: 0 },
            { id: "4", x: 890, y: 163, width: 240, height: 170, rotation: 0, imageRotation: 0 },
            { id: "5", x: 890, y: 341, width: 240, height: 169, rotation: 0, imageRotation: 0 },
            { id: "6", x: 890, y: 518, width: 240, height: 169, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h4v2-08",
        name: "PO 08 - H4V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h4_v2_08.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 0, y: 204, width: 299, height: 218, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 430, width: 299, height: 217, rotation: 0, imageRotation: 0 },
            { id: "3", x: 307, y: 204, width: 299, height: 218, rotation: 0, imageRotation: 0 },
            { id: "4", x: 307, y: 430, width: 299, height: 217, rotation: 0, imageRotation: 0 },
            { id: "5", x: 614, y: 204, width: 284, height: 443, rotation: 0, imageRotation: 0 },
            { id: "6", x: 906, y: 204, width: 283, height: 443, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h4v2-09",
        name: "PO 09 - H4V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h4_v2_09.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 73, y: 109, width: 203, height: 313, rotation: 0, imageRotation: 0 },
            { id: "2", x: 284, y: 109, width: 413, height: 313, rotation: 0, imageRotation: 0 },
            { id: "3", x: 705, y: 109, width: 413, height: 313, rotation: 0, imageRotation: 0 },
            { id: "4", x: 73, y: 429, width: 414, height: 313, rotation: 0, imageRotation: 0 },
            { id: "5", x: 495, y: 429, width: 413, height: 313, rotation: 0, imageRotation: 0 },
            { id: "6", x: 915, y: 429, width: 203, height: 313, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h4v2-10",
        name: "PO 10 - H4V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h4_v2_10.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 55, y: 135, width: 405, height: 286, rotation: 0, imageRotation: 0 },
            { id: "2", x: 55, y: 429, width: 405, height: 286, rotation: 0, imageRotation: 0 },
            { id: "3", x: 468, y: 135, width: 298, height: 469, rotation: 0, imageRotation: 0 },
            { id: "4", x: 773, y: 135, width: 360, height: 580, rotation: 0, imageRotation: 0 },       
            { id: "5", x: 468, y: 612, width: 145, height: 103, rotation: 0, imageRotation: 0 },
            { id: "6", x: 621, y: 612, width: 145, height: 103, rotation: 0, imageRotation: 0 }
        ],
    }
];